import { render, staticRenderFns } from "./HistoricoEquipoAsignadoTableComponent.vue?vue&type=template&id=104ee2b0"
import script from "./HistoricoEquipoAsignadoTableComponent.vue?vue&type=script&lang=js"
export * from "./HistoricoEquipoAsignadoTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports